<template>
    <form v-if="!isLoading" @submit.prevent="save" autocomplete="off">
        <div class="row">
            <div v-if="!readOnly" class="col-12 text-right mb-3">
                <OmniButton
                    :disabled="isSaving"
                    :isProcessing="isSaving"
                    variant="success"
                    type="submit"
                    icon="save"
                    size="lg"
                    class="mr-2"
                >
                    {{ $t('omt.gui.general.action.save') }}
                </OmniButton>
            </div>

            <div class="col-12">
                <div v-if="error" class="alert alert-danger" v-html="error"></div>
            </div>

            <div class="col-12 col-md-6 mt-2">
                <!-- Block top left -->
                <!--                @permission('locations.create|locations.edit|locations.editaddresses')-->
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">
                          {{ $t('omt.gui.location-management.label.title') }}
                        </h4>

                        <div class="form-group row">
                            <div class="col-12"><i>
                              {{ $t('omt.gui.location-management.number') }}
                            </i></div>
                            <div class="col-sm-10">
                                <span v-if="!isNewLocation" class="form-control-plaintext">{{ location.identifier }}</span>
                                <input v-else type="text" class="form-control" id="identifier"
                                       v-model.trim="location.identifier" required :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.display-name') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" class="form-control" id="display_name"
                                       v-model.trim="location.display_name" required :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.location-type') }}</i></div>
                            <div class="col-sm-10">
                                <span v-if="!isNewLocation"
                                      class="form-control-plaintext"> {{ $t(`${location.location_type.display_name}`) }} </span>
                                <select v-else v-model="location.location_type_id" class="form-control" required :readonly="readOnly">
                                    <option v-for="type in locationTypes" :value="type.id">{{ $t(`${type.display_name}`) }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.active') }}</i></div>
                            <div class="col-sm-10">
                                <div class="form-control-plaintext">
                                    <input type="checkbox" v-model="location.active" :disabled="readOnly">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- block bottom left -->
                <div class="card mt-4">
                    <div class="card-body">
                        <h4 class="card-title">{{ $t('omt.gui.location-management.contact-info') }}</h4>
                        <div v-for="emailType in emailTypes" class="form-group row">
                            <div class="col-12"><i>{{emailType.display_name}}</i></div>
                            <div class="col-sm-10">
                                <input type="email" v-model="locationEmails[emailType.id]" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div v-for="phoneType in phoneTypes" class="form-group row">
                            <div class="col-12"><i>{{ phoneType.display_name }}</i></div>

                            <div class="@if($phoneType.identifier == 'sameday') col-sm-6 @else col-sm-10 @endif">
                                <input type="text" v-model="locationPhoneNumbers[phoneType.id]" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-2">
                <!-- Block right -->
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{ $t('omt.gui.location-management.address-info') }}</h4>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-type') }}</i></div>
                            <div class="col-sm-10">
                                <select v-if="addressTypes.length > 1" v-model="selectedAddressTypeId" class="form-control" :readonly="readOnly">
                                    <option v-for="type in addressTypes" :value="type.id">{{type.display_name}}</option>
                                </select>
                                <input v-else type="text" readonly="readonly" class="form-control" :value="addressTypes[0].display_name"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-street') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].street" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-houseno') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].house_no" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-houseno-extra') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].house_no_extra" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-postal') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].zipcode" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-city') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].city" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-province') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].county" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-country') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].country" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-coords-lat') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].latitude" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12"><i>{{ $t('omt.gui.location-management.address-coords-lon') }}</i></div>
                            <div class="col-sm-10">
                                <input type="text" v-model="locationAddresses[selectedAddressTypeId].longitude" class="form-control" :readonly="readOnly"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!readOnly" class="col-12 text-right mt-2">
                <OmniButton
                    :disabled="isSaving"
                    :isProcessing="isSaving"
                    variant="success"
                    type="submit"
                    icon="save"
                    size="lg"
                    class="mr-2"
                >
                    {{ $t('omt.gui.general.action.save') }}
                </OmniButton>
            </div>
        </div>
    </form>
</template>

<script>
import _ from "lodash"

export default {
    name: "EditContactInfo",

    props: {
        location: {required: false},
        locationTypes: {required: true, type: Array},
        emailTypes: {required: true, type: Array},
        phoneTypes: {required: true, type: Array},
        addressTypes: {required: true, type: Array},
    },

    data() {
        return {
            isLoading: true,
            isSaving: false,
            error: '',
            locationAddresses: {},
            locationEmails: {},
            locationPhoneNumbers: {},
            selectedAddressTypeId: '',
        }
    },

    computed: {
        isNewLocation() {
            return this.$route.name === 'locationCreate'
        },
        readOnly() {
            return !this.hasPermission('locations.contactinfo.edit')
        },
        locationEmailsByType() {
            return _.keyBy(this.location.location_emails, email => email.location_email_type_id)
        },
        locationPhoneNumbersByType() {
            return _.keyBy(this.location.location_phone_numbers, phone => phone.location_phone_type_id)
        },
        locationAddressesByType() {
            return _.keyBy(this.location.location_addresses, address => address.location_address_type_id)
        },
    },

    mounted() {
        _.each(this.emailTypes, type => {
            this.$set(this.locationEmails, type.id,
                (typeof this.locationEmailsByType[type.id] !== 'undefined')
                    ? this.locationEmailsByType[type.id].email_address
                    : ''
            )
        })
        _.each(this.phoneTypes, type => {
            this.$set(this.locationPhoneNumbers, type.id,
                (typeof this.locationPhoneNumbersByType[type.id] !== 'undefined')
                    ? this.locationPhoneNumbersByType[type.id].phone_number
                    : ''
            )
        })
        _.each(this.addressTypes, type => {
            this.$set(this.locationAddresses, type.id,
                (typeof this.locationAddressesByType[type.id] !== 'undefined')
                    ? this.locationAddressesByType[type.id]
                    : {
                        id: '',
                        created_at: '',
                        updated_at: '',
                        location_id: '',
                        location_address_type_id: '',
                        street: '',
                        house_no: '',
                        house_no_extra: '',
                        zipcode: '',
                        city: '',
                        county: '',
                        country: '',
                        latitude: '',
                        longitude: '',
                    }
            )
        })

        this.selectedAddressTypeId = this.addressTypes[0].id
        this.isLoading = false
    },

    methods: {
        save() {
            let method, path
            this.error = ''
            this.isSaving = true
            let postData = {
                display_name: this.location.display_name,
                active: this.location.active,
                addresses: _.map(this.locationAddresses, (data, id) => {
                    data.location_address_type_id = id
                    return data
                }),
                emails: _.map(this.locationEmails, (data, id) => {
                    return {
                        location_email_type_id: id,
                        email_address: data,
                    }
                }),
                phone_numbers: _.map(this.locationPhoneNumbers, (data, id) => {
                    return {
                        location_phone_type_id: id,
                        phone_number: data,
                    }
                }),
            }

            if (this.isNewLocation) {
                postData.identifier = this.location.identifier
                postData.location_type_id = this.location.location_type_id
                method = 'post'
                path = `/api/rest/locations`
            }
            else {
                method = 'patch'
                path = `/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}`
            }

            this.$http.request({
                method: method,
                url: path,
                data: postData,
            })
                .then(response => {
                    this.$alert('Locatie opgeslagen')

                    if (method === 'post') {
                        // FIXME: the $router.push route is cleaner but doesnt work properly. I don't want to waste too much time on this so I implemented this shortcut
                        // this.$router.push(response.headers.location.toString())
                        document.location = response.headers.location
                    }
                    else {
                        this.$emit('locationUpdated')
                    }
                })
                .catch(e => {
                    try {
                        this.$alert(`Er is iets misgegaan bij het opslaan. Foutmelding: ${e.response.data.errors[0].message}`, 'danger', false)
                    } catch (e) {
                        this.$alert(`Er is iets misgegaan bij het opslaan`, 'danger', false)
                    }
                })
                .then(() => {
                    this.isSaving = false
                })
        },
    },
}
</script>


<style scoped>
input[readonly] {
    background: inherit !important;
    border: none !important;
    padding-left: 0 !important;
}
</style>
